module.exports = __webpack_public_path__ + "img/wz2.d2523d5b.png";